import { render, staticRenderFns } from "./UserPosts.vue?vue&type=template&id=2c852c2a&"
import script from "./UserPosts.vue?vue&type=script&lang=js&"
export * from "./UserPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports